module.exports = __webpack_public_path__ + "static/img/1901_8.16a7bda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_8.jpg
// module id = UK8x
// module chunks = 1